import React, { Component } from 'react';
import { InlineWidget } from 'react-calendly';
import './calendly.css';

class Calendly extends Component {
    render() {
        return (
            <div className="calendly-container">
                <InlineWidget
                    styles={{ branding: false }}
                    pageSettings={{
                        backgroundColor: 'e2dcd4',
                        hideEventTypeDetails: false,
                        hideLandingPageDetails: false,
                        primaryColor: '404040',
                        textColor: '404040',
                    }}
                    url="https://calendly.com/agile-talent-solutions/meeting-with-agile-talent-solutions?hide_gdpr_banner=1"
                />
            </div>
        );
    }
}

export default Calendly;
